import type { MaterialEntry } from "./DailyReportPage";
import AlreadySaved, { type SavedDay } from "./AlreadySaved";

interface Props {
  materials: MaterialEntry[];
  onChange: (index: number, qty: string) => void;
  // The day's deliveries already saved. Stock-in entries are point-in-time
  // deliveries — never pre-filled, always added — so they are listed instead.
  saved: SavedDay;
}

const inputClass =
  "w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 text-sm text-gray-800 shadow-theme-xs focus:border-brand-500 focus:outline-none focus:ring focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90";

export default function StepRawMaterials({ materials, onChange, saved }: Props) {
  return (
    <div>
      <h4 className="mb-1 text-base font-semibold text-gray-800 dark:text-white/90">
        Raw Material Received (Stock In)
      </h4>
      <p className="mb-4 text-xs text-gray-500 dark:text-gray-400">
        Enter quantities for materials delivered on site today. Leave blank if none.
      </p>
      <AlreadySaved saved={saved} verb="received" adds="another delivery" />

      {materials.length === 0 ? (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          No raw materials configured. Add them in Master Data.
        </p>
      ) : (
        <div className="space-y-3">
          {materials.map((m, i) => (
            <div key={m.raw_material_id} className="flex items-center gap-3">
              <label className="w-40 shrink-0 text-sm font-medium text-gray-700 dark:text-gray-300">
                {m.name}
                <span className="ml-1 text-xs text-gray-400">({m.unit})</span>
              </label>
              <input
                type="number"
                min="0"
                step="0.01"
                value={m.qty}
                onChange={(e) => onChange(i, e.target.value)}
                className={inputClass}
                placeholder="0"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
